import { render, staticRenderFns } from "./MessageCategory.vue?vue&type=template&id=41df0bec&"
import script from "./MessageCategory.vue?vue&type=script&lang=ts&"
export * from "./MessageCategory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports